import { generateFilterOptions } from '@lib/tables'
import { useSelectFilterStore } from '@app/stores/tables/SelectFilterStore'

/**
 * Ensures that a select‐style filter is present in the given store, generating its option list
 * from raw values and either registering a new filter or updating an existing one.
 * @param {object}   params
 * @param {string}   params.filterKey            Unique key under which this filter is stored.
 * @param {Array}    params.rawOptions           Array of raw values to be transformed into select options.
 * @param {string}   params.allOptionName        Label to use for the “all” (no‐filter) option.
 * @param {string}   params.groupingKey          Query‐param key under which this filter’s values will be grouped.
 * @returns {*} If the filter did not exist, returns whatever `store.registerFilter` returns;
 *              otherwise, returns undefined after updating the options in place.
 */
export function changeSelectFilterStore({
  filterKey,
  rawOptions,
  groupingKey,
  allOptionName,
}: {
  filterKey: string
  rawOptions: []
  groupingKey: string
  allOptionName?: string
}): void {
  const filterOptions = generateFilterOptions(rawOptions, allOptionName)
  const store = useSelectFilterStore()

  if (!store.getFilter(filterKey)) {
    const filter = {
      key: filterKey,
      name: filterKey,
      options: filterOptions,
      groupingKey: groupingKey,
    }

    return store.registerFilter(filter)
  }

  store.updateFilterOptions(filterKey, filterOptions)
}
